/**
 * 设备管理
 * **/

const deviceApi = {
  //获取列表
  getList: '/Device/GetList',
  //获取信息
  getInfo: '/Device/GetInfo',
  //添加
  add: '/Device/Add',
  //修改
  edit: '/Device/Edit',
  //删除
  delete: '/Device/Del',
  //导入
  import:'/Device/Import',
  //设备转移
  transPrj:'/Device/TransPrj'
}

export default deviceApi
